const PUBLIC_EXACT_ROUTES = new Set([
  '/',
  '/launch',
  '/countdown',
  '/search',
  '/chat-with-mimi',
  '/login',
  '/sms-consent',
  '/complete-registration',
  '/share/comparison',
  '/business/login',
  '/business/verify',
]);

const PUBLIC_DYNAMIC_ROUTE_PREFIXES = [
  '/building/',
  '/unit/',
  '/agent/',
];

const normalizePathname = (pathname: string): string => {
  if (!pathname) return '/';
  if (pathname === '/') return pathname;
  return pathname.replace(/\/+$/, '') || '/';
};

/**
 * Mirrors the routes in App.tsx that intentionally allow anonymous visitors.
 * An expired session on these routes should degrade to guest mode instead of
 * replacing the page with the authentication screen.
 */
export const isPublicAppRoute = (pathname: string): boolean => {
  const normalizedPathname = normalizePathname(pathname);

  return (
    PUBLIC_EXACT_ROUTES.has(normalizedPathname) ||
    ['/about-us/henry-zhao', '/about-us/calvin-luo'].includes(normalizedPathname.toLowerCase()) ||
    PUBLIC_DYNAMIC_ROUTE_PREFIXES.some((prefix) => normalizedPathname.startsWith(prefix))
  );
};

export const shouldRedirectAfterSessionFailure = (pathname: string): boolean => (
  !isPublicAppRoute(pathname)
);

export const getLoginPageInitialMode = (search: string): 'login' | 'signup' => (
  new URLSearchParams(search).get('expired') === 'true' ? 'login' : 'signup'
);
